import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Colors } from "theme/colors";

interface LabelProps {
  $disabled: boolean;
}

export const StyledLabel = styled.label<LabelProps>`
  font-size: 0.9375rem;
  margin-bottom: 0.62rem;
  cursor: pointer;

  color: ${Colors.TEXT_GRAY};
  ${(props) =>
    props.$disabled &&
    css`
      cursor: default;
      color: ${Colors.MID_GRAY};
    `}
`;
